import { expValNoExposure } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { useIsWhiteboardFeatureEnabled } from '@confluence/whiteboard-utils';
// import { useSpaceEnabledContentTypes } from '@confluence/create-blank-fabric-page/entry-points/useSpaceEnabledContentTypes';
import { useIsAllowedToCreateWhiteboard } from '@confluence/content-types-utils';
// import { useSpaceKey } from '@confluence/space-utils';

export const useIsEligibleCreateNewWhiteboard = () => {
	const { edition } = useSessionData();

	const { isWhiteboardFeatureEnabled } = useIsWhiteboardFeatureEnabled();
	const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');

	// TODO: relocate isCreateWhiteboardEnabled due to query race condition and no way
	// to update editor preset without expensively re-creating it
	// const spaceKey = useSpaceKey();
	// const { isCreateWhiteboardEnabled } = useSpaceEnabledContentTypes(spaceKey ?? undefined);

	const isAllowedToCreateWhiteboard = useIsAllowedToCreateWhiteboard();

	return {
		isEligibleCreateNewWhiteboard:
			edition !== ConfluenceEdition.FREE &&
			isWhiteboardsEnabled &&
			// isCreateWhiteboardEnabled &&
			isAllowedToCreateWhiteboard &&
			expValNoExposure('prompt_whiteboard_competitor_link', 'cohort', 'not-enrolled') !==
				'not-enrolled',
	};
};
